export default __webpack_public_path__ + "static/media/photo--lg--christina-2.75784bd5.jpg";